"use client";

import { useEffect } from "react";

import { useTranslations } from "next-intl";

import { Button } from "@/components/ui/button";
import { reportError } from "@/lib/logger";

// docs/13-error-handling.md
export default function Error({
  error,
  retry,
}: {
  error: Error & { digest?: string };
  retry: () => void;
}) {
  const t = useTranslations("errorPage");
  useEffect(() => {
    reportError(error, { digest: error.digest });
  }, [error]);

  return (
    <main id="main" role="alert" className="grid place-items-center gap-4 px-4 py-16 text-center">
      <h1 className="text-lg font-semibold">{t("title")}</h1>
      <p className="text-sm text-muted-foreground">{t("description")}</p>
      {error.digest && (
        <p className="text-xs text-muted-foreground">{t("reference", { digest: error.digest })}</p>
      )}
      <Button onClick={() => retry()}>{t("retry")}</Button>
    </main>
  );
}
